export default {
  general: {
    bottomNavigationCart: 'Cart',
    all: 'All',
    more: 'more',
    less: 'less',
    cities: 'Cities',
    signIn: 'Sign in',
    securePaymentOptions: 'Secure Payment Options',
    submit: 'Submit',
    close: 'Close',
    profile: 'Profile',
    remaining: 'left',
    // For SEO purposes titles and descriptions should follow this:
    // https://gokonfetti.atlassian.net/browse/KON-85
    // * Make surble to match the key to the page route name so that it is displayed correctly *
    titles: {
      base: 'konfetti',
      embeddedBase: 'Buy experiences and classes',
      'review-event': 'Review an experience you attended',
      'order-success': 'Your order was successful',
      'account-user-info': 'User Info',
      'account-general-info': 'General Info',
      'account-orders': 'Orders',
      'account-referral-info': 'Refer a friend',
      error: 'Page not found',
      checkout: 'Checkout',
      login: 'Login',
      contactUs: 'Contact us',
      'data-protection': 'Privacy',
      faq: 'Frequently asked questions',
      home: 'konfetti – Experiences, gift ideas and team events',
      index: 'konfetti – Experiences, gift ideas and team events',
      impressum: 'Impressum',
      myAccount: 'My Account',
      product: 'Product',
      search: 'Experiences near you. Discover gift ideas and team events.',
      partner: 'Become a partner',
      'terms-and-conditions': 'Terms and conditions',
      'terms-supplier': 'Supplier terms and conditions',
      myProfile: 'My Profile',
      teamevent:
        "Team event ideas and activities 2025 {'|'} Over {eventCount} experiences",
      'sub-domain-giftcard': 'Gutschein',
      giftcard:
        "Gift card for over {eventCount} experiences {'|'} Best gift ideas 2024",
      'event-list-page': {
        city: "Experiences in {city} 2024 {'|'} Classes near you",
        'city-category': "Experiences in {city} {'|'} Classes near you",
        general: '{title}`',
        category: '{category}',
      },
      'password-reset': 'Password reset',
      'magazine-slug': '{article}',
      'article-cartgeory-slug': '{articleCategory}',
      'magazine-pages': 'Konfetti Magazine', // this is displayed when loading a new content
      'supplier-profile': '{supplierName}: Courses and workshops',
      'partner-pricing': 'Pricing & Bundles: Plans that fit your business',
      'partner-booking-solution':
        'konfetti booking solution: Sell tickets & gift cards online',
      'login-forgot-password': 'Reset password',
      sitemap: 'Sitemap',
    },

    // The {varName} might be used as variables for manipulation in dynamic routes
    // See '~/utilities/stringVariable'
    // * Make sure to match the key to the page route name so that it is displayed correctly *
    descriptions: {
      base: '',
      checkout: '',
      contactUs:
        'Contact us via e-mail, cellphone or request an exclusive for your team or company. We will give you all the information you need. Contact us now.',
      'data-protection': '',
      faq: 'Our FAQ site answers all of your questions concerning  booking, experiences, suppliers and more. If you need more information, contact us. We will glady help you.',
      home: 'Experiences near you or online? ✓ Cooking ✓ Drawing ✓ Cocktails ✓ and more. Suitable for team events or as a gift card idea. Book now on gokonfetti.com.',
      index:
        'Experiences near you or online? ✓ Cooking ✓ Drawing ✓ Cocktails ✓ and more. Suitable for team events or as a gift card idea. Book now on gokonfetti.com.',
      impressum:
        'Contact us via e-mail, cellphone or request a team event for your team or company. We will give you all the information you need. Contact us now.',
      myAccount: '',
      product: '',
      search: '',
      partner:
        'Become a partner and reach even more people. We offer active marketing and less administrative work. Apply in just a few steps and fill out our partner form.',
      'terms-and-conditions': '',
      'terms-supplier': '',
      teamevent:
        'Team event ideas and team building activities for work? Selection on ✓ Cooking classes ✓ Drawing classes ✓ Cocktail classes and more. Book your team event now.',
      giftcard:
        'Experience gift card: ✓ More than {eventCount} experiences ✓ Last minute gift idea in 3 minutes straight to your inbox ➤ Give the gift of joy now',

      'event-list-page': {
        city: 'Classes in {city}? ✓ Cooking ✓ Painting ✓ Cocktails ✓ Craft and many more. Workshops, events and great gift ideas. Find your ❤️ classes in {city}!',
        'city-category':
          '{category} classes in {city}? ✓ Cooking ✓ Painting ✓ Cocktails ✓ Craft and many more. Workshops, events and great gift ideas. Find your ❤️ classes in {city}!',
        general: '{title}`',
        category:
          'Book {category} online at konfetti. Selection of over {eventCount} events on our website.',
      },
      'password-reset': '',
      'magazine-slug': '{description}',
      'article-category-slug': '{description}',
      'supplier-profile':
        '{supplierName}: ✓ Exclusive courses and team events ✓ Unique event location ➤ Contact us or book online',
      'account-user-info': '',
      'account-general-info': '',
      'account-orders': '',
      'account-referral-info': '',
      'partner-pricing':
        'Pricing & Bundles: Find the right package for your needs. Our pricing is tailored to your business. Get informed now',
      'partner-booking-solution':
        'konfetti booking solution: Sell tickets, team evnts and gift cards on your website. Manage your events in one software ➤ Get a free demo',
    },

    openGraphImages: {
      default: '/_nuxt3-static/logos/kft-short-logo-white-bg.webp',
      // to be added
    },

    // 404
    '404page': {
      errorAlert: {
        title: 'Ooops, this page does not exist.',
        message:
          'With more than {eventCount} classes and experiences, we have a lot more to offer.',
      },
      eventSuggestions: {
        title: 'Recommendations for you',
      },
    },

    /* Pages */
    home: 'Home',

    /* Header / Topbar */
    allEvents: 'Experiences',
    events: 'Events',
    teamEvents: 'Team events',
    teameventAnfrage: 'Send request',
    beAPartner: 'Become partner',
    supplierProfileButton: 'Contact',
    giftCards: 'Gift cards',
    kits: 'DIY-kits',
    magazine: 'Magazine',
    contactUs: 'Help & contact',
    categories: 'Categories',
    wishlist: 'Wishlist',
    account: 'Account',
    menu: 'Menu',

    /* Bottom */
    featuredBottom: 'Featured tags',

    /* General */
    emailPlaceholder: 'Please, enter your email',
    chooseLanguage: 'Choose language',
    logout: 'Logout',
    perPerson: 'person',
    perGroup: 'group',
    or: 'or',
    yes: 'Yes',
    no: 'No',
    cancel: 'Cancel',
    from: 'From ',
    edit: 'Edit',
    apply: 'Apply',
    back: 'Back',
    success: 'Success!',
    info: 'Notification',
    warning: 'Notification',
    error: 'Error!',
    online: 'Online',
    today: 'Today',
    tomorrow: 'Tomorrow',
    noSearchResultsFoundTitle: 'No results found',
    noSearchResultsFound: 'No results found for this search',
    showAllResults: 'View all experiences',
    classOnRequest: 'Class on request',
    waitlistSubscribedMessage:
      'That worked! You will receive an email once new dates go live for that event',
    waitlistUnsubscribedMessage:
      'That worked! You will no longer receive emails for new date of that event',

    /* Pagination */
    pagination: {
      resultsPerPage: '{results} per Page',
      next: 'Next',
      previous: 'Prev',
      events: 'events',
      items: 'Items',
      foundItems: 'Found Items: ',
      orderBy: 'Sort By ',
      orderByOptions: {
        relevancy: 'Relevancy',
        newest: 'Newest',
        priceAsc: 'Price: from low to high',
        priceDesc: 'Price: from high to low',
      },
    },

    /* Cart */
    cart: {
      shoppingBag: 'Cart',
      items: 'Items',
    },

    /* Form */
    form: {
      validation: {
        min: 'The minimum length should be {count}',
        required: 'This field is required',
        email: 'Please, input a valid email',
      },
    },

    select: {
      noResultsFound: 'No results found',
      emptySelect: 'No data',
    },

    faqTitle: 'Choose your question',

    /* Contact us */
    contactPhone: '030 / 257706800',
    contactPhoneAction: 'tel:030257706800',
    contactEmail: "hallo{'@'}gokonfetti.com",

    termsAndConditionsTitle: 'Terms and conditions',

    dataProtectionTitle: 'Data privacy',
    impressumTitle: 'Imprint',
    impressumContent: '',

    termsSupplierTitle: 'AGB',

    language: 'Language',
    languages: {
      english: 'English',
      german: 'German',
      french: 'French',
      spanish: 'Spanish',
      russian: 'Russian',
      italian: 'Italian',
    },

    promotionCards: {
      teamevents: {
        label: 'Request an exclusive event now',
      },
      giftcard: {
        label: 'Buy our gift card for {eventCount} experiences',
      },
      bookingSolutionGiftcard: {
        label: 'Buy a gift card, valid for all experiences',
      },
    },
    kftReadMore: {
      readMoreLabel: 'read more',
      readLessLabel: 'read less',
    },

    newsletter: {
      successMessage:
        'We received your submission! Please check your inbox to confirm your email',
      confirmationAlertTitle: 'Welcome to the konfetti newsletter!',
      confirmationAlertText: 'You’re officially subscribed!',
    },

    kftContactUsCard: {
      title: 'Do you have more questions?',
      description:
        'Just send us an email or contact us via chat service. We will be happy to help and get back to you!',
      buttonLabel: 'Email us',
    },

    copyToClipboard: 'Copy to clipboard',
    copiedToClipboard: 'Copied to clipboard',
    reloadPrompt:
      "We've made some exciting updates to enhance your experience. Please refresh the page to see the latest changes.",
  },
}
